import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import{AddNewPolicyMdl} from '../../Models/AddNewPolicy';
import { AddNewPolicyReqMdl } from '../../Models/AddNewPolicyReqMdl';
import { restURL } from '../../Models/restURL';
import { HttpClient,HttpHeaders  } from '@angular/common/http';
import { MotorStatusMdl } from '../../Models/MotorStatusMdl';


declare let $: any;
@Component({
  selector: 'ProposalForm',
  templateUrl: './ProposalForm.html',
  styleUrls: ['./ProposalForm.css']
})
export class ProposalForm {
public AddNewPolicyObj:AddNewPolicyMdl=new AddNewPolicyMdl();
public newPolicyReq:AddNewPolicyReqMdl=new AddNewPolicyReqMdl();
public newPolicyRes:AddNewPolicyReqMdl=new AddNewPolicyReqMdl();
public isShowLoading:boolean=false;
public  httpOptions = {headers: new HttpHeaders({'Content-Type':  'application/json'})};  
public apiUrl:restURL=new restURL()
public st:MotorStatusMdl=new MotorStatusMdl();
constructor(private router: Router,private http:HttpClient,private url:restURL){
  this.AddNewPolicyObj.VehicleDefionitionType="2";
  this.newPolicyReq.VDT="2";
  this.newPolicyReq.IqamaNo=sessionStorage.getItem("IqamaNo");
  this.isShowLoading=false;
}

ngAfterViewInit(){
  $(document).ready(function(){
     $(".addNew").addClass("active")
      
  }) 
} 

//declare let $: any;
checked(Event:any) {
  if (Event.target.checked) {
      this.AddNewPolicyObj.Transfer = true;
  }
  else {
      this.AddNewPolicyObj.Transfer = false;
  }
}

Proceed(){
  this.router.navigate(['./NewDashboard/InsuredInfo']);
}
BUYPolicy()
{
  //alert("trst");
  this.isShowLoading=true;
  this.newPolicyReq.RegNo=sessionStorage.getItem("RegNo");
  this.http.post<AddNewPolicyReqMdl>(this.apiUrl.baseURL+"newPolicy/addNewPolicy",this.newPolicyReq,this.httpOptions)
  .toPromise().then((result)=>{
    this.isShowLoading=false;
    this.newPolicyRes=result;
    if(this.newPolicyRes.st.StatusCode==="S")
    {
      sessionStorage.setItem("newPolicyObj",JSON.stringify(this.newPolicyRes));
      this.router.navigate(['./NewDashboard/InsuredInfo']);
    }
    else
    {
      alert(this.newPolicyRes.st.StatusDesc);
    }
  },(error)=>{
    this.isShowLoading=false;
  });
}
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/ProposalForm/ProposalForm.ts